import { render, staticRenderFns } from "./BoostActiveModal.vue?vue&type=template&id=9b01d0e8&scoped=true"
import script from "./BoostActiveModal.vue?vue&type=script&lang=js"
export * from "./BoostActiveModal.vue?vue&type=script&lang=js"
import style0 from "./BoostActiveModal.vue?vue&type=style&index=0&id=9b01d0e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b01d0e8",
  null
  
)

export default component.exports